/**
 * UsageMeter — consumption bar with "used / cap" label. Unlimited (cap === null)
 * renders an infinity symbol and no bar fill percentage.
 */
export function UsageMeter({ label, used, cap, hint }) {
  const unlimited = cap == null;
  const pct = unlimited || !cap ? 0 : Math.min(100, Math.round((used / cap) * 100));
  const nearCap = !unlimited && pct >= 80;

  return (
    <div className={`usage-meter ${nearCap ? 'is-near-cap' : ''}`}>
      <div className="usage-meter-head">
        <span className="usage-meter-label">{label}</span>
        <span className="usage-meter-value">
          {used}
          {unlimited ? ' / ∞' : ` / ${cap}`}
        </span>
      </div>
      <div
        className="usage-meter-track"
        role="progressbar"
        aria-valuemin={0}
        aria-valuemax={unlimited ? undefined : cap}
        aria-valuenow={used}
        aria-label={`${label}: ${used}${unlimited ? '' : ` of ${cap}`} used`}
      >
        <div
          className="usage-meter-fill"
          /* F-6 (V-10): a zero value renders 0% fill — no fixed minimum — so 0
             and 1 are visually distinct; unlimited-with-usage keeps its 12%
             treatment. */
          style={{ width: used === 0 ? '0%' : (unlimited ? '12%' : `${pct}%`) }}
          aria-hidden="true"
        />
      </div>
      {hint && <p className="usage-meter-hint">{hint}</p>}
    </div>
  );
}
